import { browser } from "$app/environment";
import { createLogger, type LogLevel } from "@airc/logger";

const logger = createLogger({
  service: "airc-web",
  source: browser ? "client" : "server",
  environment: import.meta.env.MODE,
  level: (import.meta.env.PUBLIC_LOG_LEVEL as LogLevel | undefined) ?? "info",
  console:
    import.meta.env.DEV ||
    (import.meta.env.PUBLIC_LOG_CONSOLE
      ? import.meta.env.PUBLIC_LOG_CONSOLE !== "false"
      : false),
  drain: import.meta.env.PUBLIC_LOG_DRAIN_URL
    ? {
        url: import.meta.env.PUBLIC_LOG_DRAIN_URL,
      }
    : undefined,
  otel: import.meta.env.PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT
    ? {
        endpoint: import.meta.env.PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT,
        headers: parseHeaders(import.meta.env.PUBLIC_OTEL_EXPORTER_OTLP_HEADERS),
        resource: {
          "service.namespace": "airc",
        },
      }
    : undefined,
  sentry: import.meta.env.PUBLIC_SENTRY_DSN
    ? {
        dsn: import.meta.env.PUBLIC_SENTRY_DSN,
        environment: import.meta.env.PUBLIC_SENTRY_ENVIRONMENT ?? import.meta.env.MODE,
        release: import.meta.env.PUBLIC_SENTRY_RELEASE,
      }
    : undefined,
});

export const logDebug = logger.debug;
export const logInfo = logger.info;
export const logWarn = logger.warn;
export const logError = logger.error;
export const captureError = logger.captureError;
export { logger };

if (browser) {
  window.addEventListener("error", (event) => {
    const err = event.error ?? new Error(event.message);
    logger.error("Unhandled error", err, {
      url: window.location.href,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    logger.error("Unhandled promise rejection", event.reason, {
      url: window.location.href,
    });
  });
}

function parseHeaders(raw?: string) {
  if (!raw) return undefined;
  const headers: Record<string, string> = {};
  for (const entry of raw.split(",")) {
    const [key, ...rest] = entry.split("=");
    if (!key) continue;
    headers[key.trim()] = rest.join("=").trim();
  }
  return headers;
}
